import * as React from 'react';
import { Banner } from '@grandvisionhq/content';
import { Heading, Article as Article$1 } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsArticle = ({ component  })=>{
    const { document: article  } = component.getModels();
    const { template  } = component.getParameters();
    const image = parseBloomreachImage(article === null || article === void 0 ? void 0 : article.image);
    var ref;
    const [link] = useBloomreachLinks([
        {
            url: (ref = article === null || article === void 0 ? void 0 : article.url) !== null && ref !== void 0 ? ref : '#'
        }
    ]);
    if (!article) {
        return null;
    }
    switch(template){
        case 'article-banner-preview':
            return /*#__PURE__*/ React.createElement(Article$1, null, image && /*#__PURE__*/ React.createElement(Banner, {
                useContainer: true,
                image: image.original,
                mobileImage: image.mobile,
                link: link
            }));
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, `Unsupported article template ${template}`);
    }
};
var Article = compose(withAnchor, withBreakpointVisibility)(CmsArticle);

export { CmsArticle, Article as default };
//# sourceMappingURL=Article.js.map
